import { ChangeDetectorRef, Component, Input, OnInit } from "@angular/core"
import { CollectionNode } from "../../../models/collectionNode.model"
import { Colors } from "../../../models/colors.model"
import { ColorCodeService } from "../../../services/color-code.service"
import { CollectionService } from "../../../services/collection.service"
import { StudentGateService } from "../../../services/student-gate.service"
import { combineLatest, Observable, Subject } from "rxjs"
import { takeUntil, tap } from "rxjs/operators"
import Utils from "../../../utils/utils"
import { PreviewService } from "../../../services/preview.service"
import NavigationNode from "../../../models/navigationNode.model"
@Component({
    selector: "app-subcollection",
    templateUrl: "./sub-collection.component.html",
    styleUrls: ["./sub-collection.component.scss"],
    standalone: false,
})
export class SubCollectionComponent implements OnInit {
    @Input() collection: CollectionNode
    @Input() styles: Colors
    isLoading: boolean = true
    isStudent: boolean = false

    public minSubCollectionCount: number = 6
    public subCollectionsCount: number = 6
    public totalSubCollectionsCount: number
    public selectedFilter: string = ""
    private destroyed$: Subject<void> = new Subject<void>()

    private filterObservable: Observable<[string, string]> = combineLatest([
        this.studentGateService.collectionFilterChoice,
        this.studentGateService.selectedGradeState,
    ]).pipe(
        takeUntil(this.destroyed$),
        tap(([_collectionFilterChoice, selectedGradeState]: [string, string]) =>
            this.setMessageGrade(_collectionFilterChoice, selectedGradeState)
        )
    )

    constructor(
        private colorCodeService: ColorCodeService,
        private cdRef: ChangeDetectorRef,
        private studentGateService: StudentGateService,
        private previewService: PreviewService
    ) {}

    ngOnInit() {
        this.filterObservable.subscribe()
        this.totalSubCollectionsCount = this.collection.children.length
        this.isStudent = Utils.hasStudentExperience()
    }

    public getBorderColor() {
        if (this.styles.isEnabled) {
            return { "border-top-color": this.styles.colorDetail }
        }
        return {
            "border-top-color": this.colorCodeService.collectionColors.defaultDetailsColor,
        }
    }

    setMessageGrade(collectionFilter: string, selectedGrade: string) {
        this.selectedFilter = collectionFilter === "All grades" ? "All grades" : selectedGrade
    }

    updateLoadingState(event: boolean) {
        this.isLoading = event
        this.cdRef.detectChanges()
    }

    public triggerMoreButton() {
        if (this.subCollectionsCount >= this.totalSubCollectionsCount) {
            this.subCollectionsCount = this.minSubCollectionCount
        } else {
            this.subCollectionsCount = this.subCollectionsCount + this.minSubCollectionCount
        }
    }

    public getNodeRouterLink(node: CollectionNode): string {
        if (this.previewService.previewOnCollection) {
            return node.getRouterLink() + "preview/"
        }
        return node.getRouterLink()
    }

    ngOnDestroy() {
        this.destroyed$.next()
        this.destroyed$.complete()
    }
}
